<app-skill-builder-select-list
	[mainTitle]="page.title"
	[subTitle]="page.subTitle"
	[options]="options"
	[custom]="custom"
	[next]="next"
>
</app-skill-builder-select-list>
